import { useState, useEffect } from "react";
import request from "../../helpers/request";
import Navigation from '../../components/navigation/navigation'
import Container from '../../components/container/container'
import Footer from '../../components/footer/footer'
import Pagination from '../../components/pagination/pagination';
import ReactModal from 'react-modal';
import Editor from 'react-simple-wysiwyg';
import { Checkbox } from "@material-ui/core";
import DatePicker from "../../components/date-picker/DatePicker";
import moment from 'moment';
import 'moment/locale/en-gb';

export default function Maintenance() {
    const [maintenanceData, setMaintenanceData] = useState([])
    const [loading, setLoading] = useState(false)
    const [updateLoading, setUpdateLoading] = useState(false)
    const [page, setPage] = useState({
        page: 1,
        last_page: null
    });
    const [eventModalIsOpen, setEventModalIsOpen] = useState(false);
    const [eventForm, setEventForm] = useState({
        id: null,
        message: '',
        end_date: null,
        auto_disable: false,
        active: false
    })

    const resetEventForm = () => {
        setEventForm({
            id: null,
            message: '',
            end_date: null,
            auto_disable: false,
            active: false
        })
        setEventModalIsOpen(false)
    }

    const getMaintenanceEvents = (page) => {
        setLoading(true)
        setMaintenanceData([])
        request(true).get('/maintenance?page=' + page).then(r => {
            setMaintenanceData(r.data.data)
            setPage({
                page: r.data.current_page,
                last_page: r.data.last_page
            });
        }).catch(error => {
            console.log(error)
            window.alert('Failed to retrieve maintenance events')
        }).finally(() => {
            setLoading(false)
        })
    }

    const submitEventForm = () => {
        setUpdateLoading(true)
        request(true).post(`/maintenance${eventForm.id ? "/update" : ''}`, eventForm).then(r => {
            getMaintenanceEvents(eventForm.id ? page.page : 1)
        }).catch(error => {
            console.log(error)
            window.alert(`Failed to ${eventForm.id ? "update" : "create"} event`)
        }).finally(() => {
            resetEventForm()
            setUpdateLoading(false)
        })
    }

    useEffect(() => {
        getMaintenanceEvents(1);
    }, [])

    useEffect(() => {
        if (eventForm.id) {
            setEventModalIsOpen(true)
        } else {
            resetEventForm()
            setEventModalIsOpen(false)
        }
    }, [eventForm.id])

    const headers = [
        "ID",
        "Message",
        "End Date",
        "Auto Disable",
        "Active",
        "Created At"
    ]

    return [
        <div className="grid grid-gap-20">
            <Navigation />
            <Container>
                <table className="table borders">
                    <thead>
                        <tr>
                            {
                                headers.map(header =>
                                    <th>{header}</th>
                                )
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            loading &&
                            <tr>
                                <td colSpan={"100%"} style={{ textAlign: 'center' }} >
                                    <i className="fa-solid fa-spinner fa-spin fa-2x" />
                                </td>
                            </tr>
                        }
                        {
                            maintenanceData.map(event =>
                                <tr className='tr-action-td'>
                                    <td>{event.id}</td>
                                    <td>{event.message}</td>
                                    <td>{event.end_date ? new Date(event.end_date).toLocaleString('en-GB') : ''}</td>
                                    <td>{event.auto_disable === true ? "Yes" : "No"}</td>
                                    <td>{event.active === true ? "Yes" : "No"}</td>
                                    <td style={{ borderRight: 0 }}>{new Date(event.created_at).toLocaleString('en-GB')}</td>
                                    <td className='action-td'>
                                        <i className="fa-solid fa-pen fa-lg"
                                            onClick={() => { setEventForm(event) }}
                                        />
                                    </td>
                                </tr>
                            )
                        }
                        {
                            !loading && maintenanceData.length === 0 &&
                            <tr>
                                {
                                    headers.map(() => <td />)
                                }
                            </tr>
                        }
                        <tr>
                            <td colSpan={"100%"} style={{ textAlign: 'center' }}>
                                <button style={{ width: '10vw' }} className="button compact background-primary colour-white" onClick={() => setEventModalIsOpen(true)} >
                                    Add Event
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                {
                    page.last_page > 1 &&
                    <Pagination page={page.page} pages={page.last_page} pageChange={getMaintenanceEvents} style={{ margin: 'auto' }} />
                }
            </Container>
            <Footer />
        </div>,
        <ReactModal
            className="card bulk-buy"
            isOpen={eventModalIsOpen}
            onRequestClose={() => resetEventForm()}
            contentLabel="Maintenance Event Modal"
        >
            <div style={{ width: '25vw' }}>
                <h3>{`${eventForm.id ? `Editing Event ID: ${eventForm.id}` : 'Create new event'} `}</h3>
                <div>
                    <h4>Message:</h4>
                    <Editor
                        value={eventForm.message ?? ''}
                        onChange={(event) => setEventForm({
                            ...eventForm,
                            message: event.target.value
                        })}
                    />
                </div>
                <div>
                    <h4>End Date:</h4>
                    <DatePicker
                        isDateTime
                        variant="inline"
                        label="End Date"
                        time={eventForm.end_date ? moment(eventForm.end_date).utc().locale('en-gb') : null}
                        onChange={(date) => setEventForm({
                            ...eventForm,
                            end_date: moment(date).utc().locale('en-gb')
                        })}
                    />
                </div>
                <div>
                    <h4>Auto Disable:</h4>
                    <Checkbox
                        checked={eventForm.auto_disable === true}
                        onChange={(event) => setEventForm({
                            ...eventForm,
                            auto_disable: event.target.checked
                        })}
                    />
                </div>
                <div>
                    <h4>Active:</h4>
                    <Checkbox
                        checked={eventForm.active === true}
                        onChange={(event) => setEventForm({
                            ...eventForm,
                            active: event.target.checked
                        })}
                    />
                </div>
                <div className="grid grid-columns-2 grid-gap-20">
                    <button className="button cancel" onClick={() => {
                        resetEventForm()
                    }}>
                        Cancel
                    </button>
                    <button className="button background-primary colour-white" onClick={submitEventForm}>
                        {
                            updateLoading ?
                                <i className='fa-solid fa-spinner fa-spin' />
                                :
                                `${eventForm.id ? 'Update' : 'Create'} Event`
                        }
                    </button>
                </div>
            </div>
        </ReactModal>
    ]
}